// frontend/src/components/company/CompanyCard.tsx

import React from 'react'
import { Link } from 'react-router-dom'
import { Card } from '@/components/common/UI/Card'
import { getInitialsAvatar, generateRandomColor, truncateText } from '@/utils/helpers'

interface CompanyCardProps {
  company: any
}

export const CompanyCard: React.FC<CompanyCardProps> = ({ company }) => {
  const avatarColor = generateRandomColor()
  const initials = getInitialsAvatar(company.name)

  return (
    <Link to={`/companies/${company.id}`}>
      <Card className="p-6 hover:shadow-lg transition-all hover:-translate-y-1 card-hover">
        <div className="flex items-center gap-4">
          {/* Logo */}
          {company.logo_url ? (
            <img
              src={company.logo_url}
              alt={company.name}
              className="w-16 h-16 rounded-lg object-cover"
            />
          ) : (
            <div
              className="w-16 h-16 rounded-lg flex items-center justify-center text-xl font-bold text-white flex-shrink-0"
              style={{ backgroundColor: avatarColor }}
            >
              {initials}
            </div>
          )}

          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-secondary-900 truncate">
              {company.name}
            </h3>
            {company.industry && (
              <p className="text-sm text-secondary-600">{company.industry}</p>
            )}
            {company.employees_count && (
              <p className="text-xs text-secondary-400">
                {company.employees_count} сотрудников
              </p>
            )}
            {company.is_verified && (
              <span className="inline-flex items-center gap-1 mt-0.5 text-green-600 text-xs">
                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                Проверено
              </span>
            )}
          </div>
        </div>

        {company.description && (
          <p className="mt-3 text-sm text-secondary-500 line-clamp-2">
            {truncateText(company.description, 120)}
          </p>
        )}

        {company.vacancies_count !== undefined && (
          <div className="mt-3 text-sm text-primary-600">
            {company.vacancies_count} вакансий
          </div>
        )}
      </Card>
    </Link>
  )
}